module.exports = __webpack_public_path__ + "assets/91bfc9919da75282dd1241fbbc4c05a5.png";